const local_settings = {
  local: {
    env: 'development',
    debug: false,
    api_host: 'https://freedom-beta.workpilots.com',
    api_version: '17',
    notifier_url: 'wss://freedom-beta.workpilots.com/ws/',
    sentry_dsn: '',
    default_lang: 'en',
    seitatech_client_url: 'https://testweid.seitatech.fi:443/mobile',
    nets_host: 'https://test.epayment.nets.eu',
    google_maps_api_key: 'AIzaSyB19Ixx947r-IT4_CbeQ22SSsTf80mY94A',
    google_places_api_key: 'AIzaSyA5pwT4TOyj-lphHRi6LPcyrELFQeEtnzw',
    google_geocode_api_key: 'AIzaSyBoHdg9kuiy0XA1Oml1ttMXgHS-ktfRLSY',
    recorder_key: '',
    recorder_url: '',
    base_domain: 'workpilots.com',
    default_subdomain: 'localhost:9000',
    default_subdomains: ['localhost:9000', 'freedom-beta', 'web'],
    supported_languages: ['en', 'fi', 'sv', 'ru', 'fa', 'uk'],
  },
  local0: {
    env: 'development',
    debug: false,
    api_host: 'https://freedom-beta.workpilots.com',
    api_version: '17',
    notifier_url: 'wss://freedom-beta.workpilots.com/ws/',
    sentry_dsn: '',
    default_lang: 'en',
    seitatech_client_url: 'https://testweid.seitatech.fi:443/mobile',
    nets_host: 'https://test.epayment.nets.eu',
    google_maps_api_key: 'AIzaSyB19Ixx947r-IT4_CbeQ22SSsTf80mY94A',
    google_places_api_key: 'AIzaSyA5pwT4TOyj-lphHRi6LPcyrELFQeEtnzw',
    google_geocode_api_key: 'AIzaSyBoHdg9kuiy0XA1Oml1ttMXgHS-ktfRLSY',
    recorder_key: '7dznFwBoYnUHA56E1IAo',
    recorder_url: 'https://replay.workpilots.com/ingest',
    supported_languages: ['en', 'fi', 'sv', 'ru', 'fa', 'uk'],
  },
  test: {
    env: 'beta',
    debug: true,
    api_host: 'https://freedom-beta.workpilots.com',
    api_version: '17',
    notifier_url: 'wss://freedom-beta.workpilots.com/ws/',
    sentry_dsn: 'https://c6ae122c53024a41a264ffe0a5916add@sentry.io/1399550',
    default_lang: 'en',
    seitatech_client_url: 'https://testweid.seitatech.fi:443/mobile',
    nets_host: 'https://test.epayment.nets.eu',
    google_maps_api_key: 'AIzaSyA2jYtuKrBta0yCtQmYqbxptQQJR2ZUCic',
    google_places_api_key: 'AIzaSyDXwVAP58LrGHaEVuU8QTDMjR7k_ICeGyU',
    google_geocode_api_key: 'AIzaSyBcr_M1Nan-jvrtmhD9F7flSLIQPWuhSI4',
    base_domain: 'workpilots.com',
    default_subdomain: 'freedom-beta',
    default_subdomains: ['localhost:9000', 'freedom-beta', 'web'],
    supported_languages: ['en', 'fi', 'sv', 'ru', 'fa', 'uk'],
  },
  beta: {
    env: 'beta',
    debug: true,
    api_host: 'https://freedom-beta.workpilots.com',
    api_version: '17',
    notifier_url: 'wss://freedom-beta.workpilots.com/ws/',
    sentry_dsn: 'https://69aaa1c65ac04b7f87008c467370412c@o193586.ingest.sentry.io/1428521',
    default_lang: 'en',
    seitatech_client_url: 'https://testweid.seitatech.fi:443/mobile',
    nets_host: 'https://test.epayment.nets.eu',
    google_maps_api_key: 'AIzaSyC-_H-g2siau7RwpJpPRlbrFKyY4PO8gX4',
    google_places_api_key: 'AIzaSyAh8dl4JG0l6dqVGK-8F6rq8cfIEFXRN1s',
    google_geocode_api_key: 'AIzaSyBDFvRxHfXyId6n92uDVXt0Dm5vdcr_PSY',
    recorder_key: 'AeNVrTzXRFCpFBnkjTKp',
    recorder_url: 'https://replay.workpilots.com/ingest',
    base_domain: 'workpilots.com',
    default_subdomain: 'freedom-beta',
    default_subdomains: ['localhost:9000', 'freedom-beta', 'web'],
    supported_languages: ['en', 'fi', 'sv', 'ru', 'fa', 'uk'],
  },
  production: {
    env: 'production',
    debug: false,
    api_host: 'https://web.workpilots.com',
    api_version: '17',
    notifier_url: 'wss://web.workpilots.com/ws/',
    sentry_dsn: 'https://9459010e7dc9401ab9d24805ffddf8c3@o193586.ingest.sentry.io/1532351',
    default_lang: 'en',
    seitatech_client_url: 'https://weid.seitatech.fi:443/mobile',
    nets_host: 'https://epayment.nets.eu',
    google_maps_api_key: 'AIzaSyA24f78xWn8Mx01Gah5V_QDggXSuKUQ-As',
    google_places_api_key: 'AIzaSyDGkaD_s8HxO-jDsYAn8oEDVa0uxTTLPsI',
    google_geocode_api_key: 'AIzaSyApAzn0SUXgXCkQ9y5A4B2HuVIyoaqv0gw',
    recorder_key: 'K9C0GgID0N244T3MwoiP',
    recorder_url: 'https://replay.workpilots.com/ingest',
    base_domain: 'workpilots.com',
    default_subdomain: 'web',
    default_subdomains: ['localhost:9000', 'freedom-beta', 'web'],
    supported_languages: ['en', 'fi', 'sv', 'ru', 'fa', 'uk'],
  },
};

export { local_settings };
